import { renderInput } from "./renderInput";

export default renderInput;
